module.exports = __webpack_public_path__ + "img/图片9.d67687af.png";